import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

/** MSAL can cache one account per B2C policy. The redirect-return account that
 * App marks active must win over arbitrary cache array ordering. */
export const selectActiveAccount = (
    instance: Pick<IPublicClientApplication, 'getActiveAccount'>,
    accounts: AccountInfo[],
) => instance.getActiveAccount() ?? accounts[0];
